import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Box = styled.div`
	position: relative;
	border-radius: 16px;
	background: rgba(0, 0, 0, 0.6);
	box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.25);
	box-sizing: border-box;
	width: 92%;
	padding: 0.37em;
	height: 3.3em;
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media (orientation: landscape) {
		flex-direction: column-reverse;
		height: 6em;
		width: 8em;
		gap: 0.4em;
	}
`;

export const Button = styled(ThemeButton)`
	padding: 0.2em;
	width: 70%;
	height: 100%;
	font-size: 1em;
	border-radius: 12px;
	//font-size: 0.7em;

	@media (orientation: landscape) {
		width: 100%;
		height: 50%;
	}
`;

export const RewardContainer = styled.div`
	//background-color: rgba(0, 0, 0, 0.25);
	border-radius: 15px;
	font-size: 0.9em;
	width: 4.2em;
	height: 4.2em;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const RewardItem = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	position: relative;
	//padding: 0.21em;
`;

export const RewardAmountContainer = styled.div`
	position: absolute;
	min-width: 120%;
	display: flex;
	align-items: center;
	justify-content: center;
	bottom: -0.8em;
`;

export const RewardAmount = styled.div`
	color: #fff;
	font-weight: 700;
	font-size: 1.25em;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: right;
	font-family: "Baloo";
	font-weight: 300;
	text-shadow: 0.071em 0.071em 0em #000;
	-webkit-text-stroke-width: 0.12em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
`;

export const ItemImage = styled.img`
	min-width: 2.5em;
	height: 2.5em;
	object-fit: contain;
	justify-self: center;
	align-self: center;
`;
